<div>
  @if (installmentWindow !== 'no_installment') {
<span>
    {{ 'PAYMENT_TERMS_SELECTOR.TERM_SUMMARY.installment' | pluralizeKey:detailParams['count'] | translate:detailParams }}
  </span>
}
  @if (['many_day_interval', 'one_day_interval'].includes(installmentWindow)) {
<span>
    {{ 'PAYMENT_TERMS_SELECTOR.TERM_SUMMARY.WINDOW.' + installmentWindow | pluralizeKey:detailParams['interval'] | translate:detailParams }}
  </span>
}
  @if (!['many_day_interval', 'one_day_interval'].includes(installmentWindow)) {
<span>
    {{ 'PAYMENT_TERMS_SELECTOR.TERM_SUMMARY.WINDOW.' + installmentWindow | pluralizeKey:detailParams['count'] | translate:detailParams }}
  </span>
}
</div>

<small>{{ paymentTerm.description }}</small>
